import { isNull, isSome } from '@mbfab/shared'
import { useEffect, useRef, useState } from 'react'

// v1 の @mbfab/frontend-common#useResize を client へ移植したもの（use-local-storage-state.ts と同じ理由:
// antd 依存の frontend-common 全体を workspace 依存にしないため、React だけで完結するこのフックを複製する）。
// 印刷プレビューの表示枠サイズを監視し、A4 帳票を枠に収まる倍率へ自動調整するために使う
export function useResize() {
  const [rect, setRect] = useState<DOMRectReadOnly | undefined>(undefined)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    if (isNull(element)) {
      return
    }
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (isSome(entry)) {
        setRect(entry.contentRect)
      }
    })
    observer.observe(element)
    return () => {
      observer.disconnect()
    }
  }, [])

  return { ref, rect }
}
